import React from 'react';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { Translate } from '@mui/icons-material';
import { LANGUAGES, Language } from './languages';
import { useTranslation } from './store';

export default function LanguageSwitcher({ tone = 'dark' }: { tone?: 'dark' | 'light' }) {
  const { language, setLanguage, t } = useTranslation();
  const onDark = tone === 'dark';

  return (
    <Select
      size="small"
      value={language}
      onChange={(event: SelectChangeEvent) => void setLanguage(event.target.value as Language)}
      inputProps={{ 'aria-label': t('common.language') }}
      startAdornment={<Translate fontSize="small" sx={{ mr: 0.75, color: onDark ? 'rgba(255,255,255,0.7)' : 'text.secondary' }} />}
      sx={{
        minWidth: 128,
        height: 36,
        fontSize: '0.875rem',
        color: onDark ? '#fff' : 'text.primary',
        bgcolor: onDark ? 'rgba(255,255,255,0.06)' : '#fff',
        '& .MuiOutlinedInput-notchedOutline': { borderColor: onDark ? 'rgba(255,255,255,0.3)' : undefined },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: onDark ? '#fff' : undefined },
        '& .MuiSelect-icon': { color: onDark ? 'rgba(255,255,255,0.7)' : undefined },
      }}
    >
      {LANGUAGES.map(item => (
        <MenuItem key={item.code} value={item.code} lang={item.code}>
          {item.nativeName}
        </MenuItem>
      ))}
    </Select>
  );
}
